<template>
  <div class="control-panel">
    <font-awesome-icon
      icon="times"
      size="2x"
      class="float-right control-btn"
      @click="closePanel()"
    />
    <h4>{{ serviceGroup.name }}</h4>
    <template v-for="(actors, argument) in getGroupedControlActors">
      <argument-control :actors="actors" :argument="argument" :key="argument" />
    </template>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import ControlPanelMixin from '@/mixins/ControlPanel';
import ArgumentControl from '@/components/service-groups/ArgumentControl';

export default {
  name: 'ControlPanel',
  mixins: [ControlPanelMixin],
  props: {
    place: {
      type: Object,
      required: true,
    },
    serviceGroup: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'getControlActorsForServices',
      'getServicesByPlaceAndGroup',
    ]),
    getGroupedControlActors() {
      const services = this.getServicesByPlaceAndGroup(
        this.place,
        this.serviceGroup,
      );
      if (services) {
        return _.groupBy(
          this.getControlActorsForServices(services),
          'argument',
        );
      }
      return [];
    },
  },
  components: {
    ArgumentControl,
  },
};
</script>

<style scoped>

</style>
